export default {
  lowElevation: '0 1px 6px rgba(12, 44, 84, 0.12)',
  highElevation:
    '0 4px 14px rgba(12, 44, 84, 0.15), 0 0 2px rgba(12, 44, 84, 0.25)',
} as const;
